import styled, { createGlobalStyle, css } from 'styled-components'
import { theme } from '@elamajs/ui-kit'

export const Global = createGlobalStyle`
  #new-commission-calculator,
  #commission-calculator-new-partner {
    width: 100%;
    margin: 0;
    font-family: Navigo, Arial, Helvetica, sans-serif;

    @media screen and (min-width: 768px) {
      margin: 20px 0 0;
      padding-left: 20px;
      padding-right: 20px;
    }
  }
`

export const LoaderContainer = styled.div`
  border: 2px solid #edeff3;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 708px;
  @media (max-width: 767px) {
    margin-left: 5px;
    margin-right: 5px;
  }
`

export const Container = styled.div`
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
  border: 2px solid #edeff3;
  border-radius: 15px;
  @media (max-width: 767px) {
    margin-left: 5px;
    margin-right: 5px;
  }
`

export const ContentWrapper = styled.div``

export const Content = styled.div<{ isNewPartner: boolean }>`
  padding: 60px;
  background-color: #fff;
  font-size: 13px;
  line-height: 20px;
  color: ${theme.palette.primaryText};
  overflow-y: auto;

  ${({ isNewPartner }) => {
    if (isNewPartner) {
      return css`
        height: 551px;
      `
    }

    return css`
      height: 523px;
    `
  }};

  @media screen and (max-width: 1279px) {
    padding: 50px 40px;
    height: 503px;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  @media screen and (max-width: 767px) {
    padding: 40px 15px 40px;
    height: 611px;
  }
`

export const Preview = styled.div`
  background-color: #ebeffe;
`

export const ContentLayout = styled.div`
  display: flex;
  flex-direction: column;

  ${ContentWrapper} {
    width: 760px;
  }

  @media screen and (max-width: 1279px) {
    ${ContentWrapper} {
      width: 520px;
    }
  }

  @media screen and (max-width: 999px) {
    ${ContentWrapper} {
      width: 100%;
    }
  }

  @media screen and (min-width: 1000px) {
    flex-direction: row;

    ${Preview} {
      flex: 1;
    }
  }
`

export const SelectSystemsContainer = styled.div`
  margin-bottom: 50px;

  span[class^='Checkboxstyled__CheckboxIndicator'] {
    border-radius: 5px;
  }

  button[class^='InputTextstyled__Button'] {
    color: ${theme.palette.white};
  }

  div[class^='MultiSelectstyled__StyledMultiSelect'],
  div[class^='Popupstyled__ContentWrapper'] {
    width: 270px;
  }

  button {
    background-color: #3a64f8;
    border-radius: 5px;
  }

  button:hover {
    background-color: #6b8bfa;
    border-color: #6b8bfa;
  }

  @media screen and (min-width: 768px) {
    div[class^='MultiSelectstyled__StyledMultiSelect'],
    div[class^='Popupstyled__ContentWrapper'] {
      width: 400px;
    }
  }
`

export const SelectSystemsTitle = styled.p`
  margin: 0 0 15px;
  font-size: 20px;
  line-height: 32px;
  font-weight: 400;
  color: ${theme.palette.black[20]};

  @media screen and (max-width: 767px) {
    font-size: 16px;
    line-height: 24px;
  }
`

export const SystemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
`

export const SystemSliderContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const SystemSliderInfoWrapper = styled.div``

export const SystemSliderTitle = styled.p`
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  line-height: 24px;
  ${theme.palette.black[20]};
`

export const SystemSliderTextContainer = styled.div`
  margin: 10px 0 20px;

  @media (max-width: 999px) {
    margin: 10px 0 10px;
  }
`

export const SystemSliderAdditionalText = styled.div`
  font-size: 12px;
  line-height: 18px;
  margin: 0;
  color: #858fad;
  width: 100%;
`

export const SystemSliderAdditionalError = styled.p`
  display: block;
  font-size: 12px;
  line-height: 18px;
  color: #fb606d;
  margin: 0;

  @media (max-width: 1279px) {
    width: 275px;
  }

  @media (max-width: 999px) {
    width: 100%;
  }
`

export const SystemSlider = styled.div`
  margin: 10px 0 0;
  display: flex;
  gap: 40px;

  div[class^='Sliderstyled__Track'] {
    background-color: #edeff3;
  }

  div[class^='Sliderstyled__TrackFill'] {
    background-color: #3a64f8;
  }

  div[class^='Sliderstyled__SliderInner'] {
    width: 270px;
    min-width: 270px;
  }

  span[class^='Sliderstyled__Range'] {
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
  }

  @media screen and (max-width: 767px) {
    flex-wrap: wrap;
    gap: 20px;

    div[class^='Sliderstyled__SlideWrap'] {
      gap: 4px;
    }
  }

  @media screen and (min-width: 768px) {
    div[class^='Sliderstyled__SliderInner'] {
      width: 306px;
      min-width: 306px;
    }

    div[class^='Sliderstyled__Marks'] {
      div:last-child {
        font-size: 12px;
      }
    }
  }

  @media screen and (min-width: 1000px) {
    margin: 0;

    div[class^='Sliderstyled__SliderWrapper'] {
      display: none;
    }
  }
`

export const SystemTurnoverWrapper = styled.div`
  position: relative;

  input {
    height: 50px;
    font-family: Navigo, Arial, Helvetica, sans-serif;
    border-color: #c2c7d6;
    font-size: 14px;
    line-height: 20px;
    border-radius: 5px;
  }

  div[class^='InputCurrencystyled__Wrapper'] {
    height: 50px;
  }
  div[class^='InputCurrencystyled__CurrencySymbol'] {
    height: 50px;
    font-family: Navigo, Arial, Helvetica, sans-serif;
    font-size: 14px;
  }

  @media (max-width: 767px) {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: flex-end;
    gap: 20px;
    width: 100%;
  }
`

export const SystemTurnoverText = styled.div<{ sliderOffset: boolean }>`
  font-size: 12px;
  line-height: 18px;
  color: ${theme.palette.black[50]};
  text-align: right;
  padding-right: 15px;
  white-space: nowrap;
  position: absolute;

  right: 0;

  ${({ sliderOffset }) => {
    if (sliderOffset) {
      return css`
        top: -55px;
      `
    }

    return css`
      top: -40px;
    `
  }};

  @media (max-width: 767px) {
    position: static;
    padding-right: 0;
  }
`

export const ResultContainer = styled.div<{ isNewPartner?: boolean }>`
  display: flex;
  flex-direction: column;
  padding: 60px 40px;
  height: 100%;
  position: relative;

  @media screen and (max-width: 1279px) {
    padding: 50px 40px;
  }

  @media screen and (max-width: 999px) {
    ${({ isNewPartner }) => {
      if (isNewPartner) {
        return css`
          flex-direction: row;
          flex-wrap: wrap;
          align-items: center;
        `
      }

      return css`
        padding: 40px 15px;
        flex-direction: column;
        align-items: flex-start;
      `
    }};
  }

  @media screen and (max-width: 767px) {
    padding: 40px 15px;
    flex-direction: column;
    align-items: flex-start;
  }
`

export const Result = styled.div<{ isNewPartner?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 30px;
  background-color: ${theme.palette.white};
  border-radius: 10px;

  @media screen and (max-width: 999px) {
    ${({ isNewPartner }) => {
      if (isNewPartner) {
        return css`
          width: 450px;
          flex-direction: row;
        `
      }

      return css`
        flex-direction: row;
        width: 100%;
      `
    }};
  }

  @media screen and (max-width: 767px) {
    flex-direction: column;
    width: 100%;
  }
`

export const ResultItem = styled.div``

export const ResultTitle = styled.div`
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: ${theme.palette.black[40]};
`

export const ResultValue = styled.div<{ bigger?: boolean }>`
  display: flex;
  align-items: center;
  margin: 5px 0 0;
  color: ${theme.palette.black[20]};
  font-family: coolvetica, Arial, Helvetica, sans-serif;
  font-weight: 400;

  ${({ bigger }) => {
    if (bigger) {
      return css`
        font-size: 30px;
        line-height: 42px;
      `
    }

    return css`
      font-size: 24px;
      line-height: 30px;
    `
  }};
`

export const ResultInfo = styled.div`
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  color: ${theme.palette.black[50]};
  margin: 20px 0 0;

  br {
    display: none;
  }

  @media (max-width: 999px) {
    order: 3;
    br {
      display: block;
    }
  }

  @media (max-width: 767px) {
    margin-left: 0;
    margin-top: 20px;
    order: initial;

    br {
      display: none;
    }
  }
`

export const ResultInfoDisclamer = styled(ResultInfo)`
  margin: 5px 0 0 0;
`

export const ResultInfoLink = styled.a`
  text-decoration: underline;
`

export const ResultError = styled.div`
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  color: #fb606d;
  margin: 30px 0 -15px;

  @media (max-width: 999px) {
    position: absolute;
    bottom: 20px;
  }

  @media (max-width: 767px) {
    position: static;
  }
`

export const EmptyResult = styled.div`
  padding: 30px 25px 30px 30px;
  border-radius: 10px;
  background-color: ${theme.palette.white};

  @media screen and (max-width: 767px) {
    padding: 30px 20px;
  }
`

export const EmptyResultTitle = styled.h2`
  font-family: Navigo, Arial, Helvetica, sans-serif;
  font-size: 24px;
  line-height: 30px;
  font-weight: 400;
  margin-top: 12px !important;
`

export const EmptyResultText = styled.p`
  margin: 15px 0 0;
  font-size: 16px;
  line-height: 24px;
`

export const MultiSelect = styled.div`
  width: 400px;

  label[class^='ViewDefaultstyled__DefaultLabel'] {
    max-height: 50px;
    height: 50px;
    padding: 12px 35px 10px 18px;
  }

  span[class^='SelectWrapperstyled__Label'] {
    font-size: 14px;
    line-height: 20px;
  }

  div[class^='Popupstyled__Popup'] {
    z-index: 1000;
  }

  @media screen and (max-width: 767px) {
    width: 100%;
  }
`

export const PartnerLink = styled.a`
  margin-top: auto;

  span {
    font-size: 14px;
    line-height: 20px;
  }

  @media screen and (max-width: 999px) {
    margin-top: 0;
    margin-left: 29px;
  }

  @media screen and (max-width: 767px) {
    margin-left: 0;
    margin-top: 60px;
  }
`
